import { cloneObject, getFields } from "../../../../utils";

const fields = [
    'network',
    'healthPlan',
    'service',
    'specialty',
    'uf',
    'city',
    'districts'
];

const schema = {
    ...cloneObject(getFields(fields))
}

schema.districts = {
    id: 'districts',
    label: ' ',
    required: false,
    type: 'checkbox',
    options: [
        {
            codigo: 1,
            nome: 'Vila Esmeralda'
        },
    ]
}

schema.origin = {
    id: 'origin',
    label: 'Origem',
    required: false,
    type: 'text',
    help: 'Informe o endereço: Exemplos: Av Paulista 100 SP',
    placeholder: 'Logradouro Nr Bairro Cidade',
}

schema.mail = {
    id: 'mail',
    label: 'Digite um email válido para o recebimento de sua pesquisa.',
    required: false,
    type: 'email',
    placeholder: 'seunome@empresa.com.br',
}

export default schema;